export function normalizeBookingGender(value) {
  return { male: "Male", female: "Female", other: "Other" }[String(value || "").trim().toLowerCase()] || "";
}
